import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import Sidebar from "./Sidebar";

const AppLayout = ({ children }) => {
  return (
    <Flex minH="100vh">
      <Sidebar />
      <Box flex="1" bg="gray.50" p={6}>
        {children}
      </Box>
    </Flex>
  );
};

export default AppLayout;
